module.exports = __webpack_public_path__ + "static/m2-a11ee72b57049d69bc4fa139d94a5fec.jpg";